import emptyFunction from "@jnctn/core/utilities/emptyFunction";
import { SetStateAction, ReactNode, useContext } from "react";
import { Dispatch, createContext, useMemo, useState } from "react";

const AssignCredentialContext = createContext<{
  createNew: boolean;
  setCreateNew: Dispatch<SetStateAction<boolean>>;
}>({
  createNew: false,
  setCreateNew: emptyFunction,
});

function useCreateAssignCredentialContext() {
  const [createNew, setCreateNew] = useState(true);
  return useMemo(
    () => ({
      createNew,
      setCreateNew,
    }),
    [createNew, setCreateNew]
  );
}

export default function AssignCredentialProvider({
  children,
}: {
  children: ReactNode;
}) {
  const value = useCreateAssignCredentialContext();
  return (
    <AssignCredentialContext.Provider value={value}>
      {children}
    </AssignCredentialContext.Provider>
  );
}

export function useAssignCredentialContext() {
  const context = useContext(AssignCredentialContext);
  if (!context) {
    throw new Error("No provider for AssignCredentialContext");
  }
  return context;
}
